import React, { useState, useRef, useEffect } from 'react';
import Header from './gapsy-header';
import Navigation from './gapsy-Cnavigation';
import Footer from './gapsy-footer';
import "bootstrap/dist/css/bootstrap.min.css"
import 'bootstrap-icons/font/bootstrap-icons.css';
import styles from '../assets/css/gapsy-dashboard.module.css';
import dropdownStyles from '../assets/css/gapsy-download-dropdown.module.css';
import { useNavigate, useLocation } from 'react-router-dom';
import '../assets/css/gapsybdmupload.css';
import '../assets/css/TemplateForm.css';
import '../assets/css/Operators.css';
import '../assets/css/DEMchecker.css';
import axios from 'axios';
import * as XLSX from 'xlsx';
import '../assets/css/RDMupload.css';
import '../assets/css/style.css';
import '../assets/css/AdminautoBDM.css';
import { FbcDepartmentDropdown } from "../components/Dropdown";
import { Modal, Button, Form, Dropdown, DropdownButton, FaChevronDown } from 'react-bootstrap';
import { BackButton, PreViewButton, previewButtonStyle, UploadButtonStyle, bootstrapbuttonclass, cancelButtonStyle, submitButtonStyle, closeButtonStyle, HeadingStyle, h1, h2, h3, h4, h5, h6, h7, UploadLoadingIcon } from "../components/Propertyfile";
import { upload3001, UploadDemtemplate, Uploadtemplate, PortURL, dropdownlist, ListAlldept, userWisedept } from '../components/ApiProperty';
import tableStyles from '../assets/css/sharedTableStyles.module.css';
import shariahStyles from '../assets/css/GapsyShariahList.module.css';
import { useSession } from '../components/SessionContext';
import StatusBadge from "../components/GapsyShariahStatusBadge";


const GapsyComplianceListReview = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const customMessage = location.state?.message;
    const found = location.state?.found;
    const [listData, setListData] = useState([]);

    const allowedStatuses = [
        "Past Data Approved",
        "Data Approved",
        "Past Data Pending for Maker Modification",
        "Pending for Maker Modification",
        "Past Data Pending for Checker Review",
    ];

    const getListData = async () => {
        try {
            const response = await fetch(`/jsonfiles/10192_compliance.json`); // Replace with your API

            if (!response.ok) {
                throw new Error("Failed to fetch data");
            }

            const data = await response.json();

            setListData(data);
        } catch (err) {
            console.error("Error fetching list data:", err);
            setListData([]);
        }
    };

    useEffect(() => {
        getListData();
    }, []);


    const handleDashboard = () => {
        navigate("/gapsyCdashboard"); // Change if your dashboard route is different
    };

    const [search, setSearch] = useState("");

    const filteredData = listData
        // .filter(item => allowedStatuses.includes(item.status))
        .filter(item =>
            Object.values(item)
                .join(" ")
                .toLowerCase()
                .includes(search.toLowerCase())
        );

    const showReinstatedColumns = filteredData.some(
        row => row.reinstated_by && row.reinstated_by.trim() !== ""
    );

    const showUploadedToSAMAColumns = filteredData.some(
        row => row.uploadedtosama_by && row.uploadedtosama_by.trim() !== ""
    );

    const Overridenby = filteredData.some(
        row => row.Overridden_by && row.Overridden_by.trim() !== ""
    );



    return (
        <div className={`d-flex flex-column min-vh-100 ${styles.pageFullBackground}`}>

            <Header />
            <Navigation />

            {/* Breadcrumb */}
            <div className="px-4 pt-2 pb-1">
                <div className="d-flex justify-content-between align-items-center flex-wrap">
                    <div>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mb-1">
                                <li className={`breadcrumb-item`}>
                                    <a onClick={handleDashboard} className={`text-dark ${styles.breadcrumbLink}`}>
                                        <i className="bi bi-house me-2" style={{ cursor: "pointer" }}></i>/
                                    </a>
                                    {/* <span className={styles.separator}>/</span> */}
                                </li>
                                <li className={`breadcrumb-item active ${styles.breadcrumbItem}`} aria-current="page">
                                    <i className="bi bi-shield-lock me-2"></i>1.0 BSF
                                </li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>

            <main className="flex-grow-1" style={{ margin: 0, padding: 0, background: "none" }}>
                <div className={`${shariahStyles.pageContainer} container px-4 pt-2 pb-0`}>

                    {/* Header */}
                    <div className="row align-items-center mb-1">

                        <div className="col-md-5">
                            <h6 className="mb-0">
                               Compliance Reporting
                            </h6>
                        </div>

                        <div className="col-md-7">

                            <div className="d-flex justify-content-end align-items-center gap-2">

                                <div className={`input-group input-group-sm ${shariahStyles.searchGroup}`}>
                                    <span className={`input-group-text ${shariahStyles.searchIcon}`}>
                                        <i className="bi bi-search"></i>
                                    </span>

                                    <input
                                        type="text"
                                        className={`form-control ${shariahStyles.searchInput}`}
                                        placeholder="Search..."
                                        value={search}
                                        onChange={(e) => setSearch(e.target.value)}
                                    />
                                </div>
                                {localStorage.getItem("userRole") === "Maker" && (
                                    <button
                                        className="btn btn-primary btn-sm"
                                        onClick={() => navigate("/gapsyComplianceReview")}
                                    >
                                        <i className="bi bi-plus-circle me-1"></i>
                                        Add New
                                    </button>
                                )}

                            </div>

                        </div>

                    </div>


                    <div className={tableStyles.shariahTableWrapper}>
                        <div className="table-on-homepage-only">

                            <table className={`table table-bordered table-hover text-center customScrollTable ${tableStyles.customScrollTable} ${tableStyles.shariahCustomScrollTable}`}>

                                <thead className="thead-light">
                                    <tr>
                                        <th>Reporting Date</th>
                                        <th>Entered On</th>
                                        <th>Status</th>
                                        <th>Reported By</th>
                                        <th>Reviewed By</th>

                                        {showReinstatedColumns && (
                                            <>
                                                <th>Reinstated Details</th>
                                            </>
                                        )}

                                        {showUploadedToSAMAColumns && (
                                            <>
                                                <th>SAMA Upload Details</th>
                                            </>
                                        )}
                                        {Overridenby && (
                                            <>
                                                <th>Overridden Details</th>
                                            </>
                                        )}

                                        <th>Action</th>
                                    </tr>
                                </thead>

                                <tbody>

                                    {filteredData.map((row, index) => (

                                        <tr key={index}>

                                            {/* Reporting Date */}

                                            <td>
                                                <div className={`d-flex align-items-center`}>

                                                    <div className="icon-box text-primary">
                                                        <i className="bi bi-calendar-event"></i>
                                                    </div>

                                                    <span className={shariahStyles.dateText}>
                                                        {row.reporting_date}
                                                    </span>

                                                </div>
                                            </td>

                                            {/* Entered On */}

                                            <td>
                                                <div className="d-flex align-items-center">

                                                    <div className="icon-box text-primary">
                                                        <i className="bi bi-calendar3"></i>
                                                    </div>

                                                    <span className="ms-3">
                                                        {row.submitted_date}
                                                    </span>

                                                </div>
                                            </td>

                                            {/* Status */}

                                            {/* <td className="text-start">

                                            <span
                                                className={`${shariahStyles.statusBadge} ${row.status === "Saved"
                                                    ? shariahStyles.saved
                                                    : row.status === "Send for Checker Review"
                                                        ? shariahStyles.review
                                                        : row.status === "Returned for Edit"
                                                            ? shariahStyles.returned
                                                            : shariahStyles.approved
                                                    }`}
                                            >
                                                <i className="bi bi-check-circle me-2"></i>
                                                {row.status}
                                            </span>

                                        </td> */}
                                            <td className="text-start">
                                                <StatusBadge status={row.status} />
                                            </td>
                                            {/* Reported By */}
                                            {/* Reported By */}
                                            {/* Reviewed By */}
                                            {/* Reported By */}
                                            <td>
                                                {row.reported_by ? (
                                                    <div className={shariahStyles.userInfo}>
                                                        <i className="bi bi-person-circle me-2 text-primary"></i>

                                                        <div>


                                                            <small className="text-muted">
                                                                {row.reported_by}
                                                            </small>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    ""
                                                )}
                                            </td>
                                            <td>
                                                {row.status !== "Pending for Checker Review"
                                                    && row.status !== "Past Data Pending for Checker Review"
                                                     && row.reviewed_by ? (
                                                    <div className={shariahStyles.userInfo}>
                                                        <i className="bi bi-person-circle me-2 text-primary"></i>

                                                        <div>
                                                            <small className="text-muted">
                                                                {row.reviewed_by}
                                                            </small>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    ""
                                                )}
                                            </td>

                                            {/* Reinstated On */}
                                            {showReinstatedColumns && (
                                                <td>
                                                    <div className="d-flex flex-column gap-1">
                                                        {row.reinstated_by && (
                                                            <>
                                                                <div className="d-flex align-items-center">
                                                                    <div className="icon-box text-primary">
                                                                        <i className="bi bi-calendar3"></i>
                                                                    </div>
                                                                    <span className="ms-2">{row.submitted_date}</span>
                                                                </div>

                                                                <div className="d-flex align-items-center">
                                                                    <div className="icon-box text-primary">
                                                                        <i className="bi bi-person-check"></i>
                                                                    </div>
                                                                    <span className="ms-2">{row.reinstated_by}</span>
                                                                </div>
                                                            </>
                                                        )}
                                                    </div>
                                                </td>
                                            )}
                                            {showUploadedToSAMAColumns && (
                                                <td>
                                                    <div className="d-flex flex-column gap-1">
                                                        {row.uploadedtosama_by && (
                                                            <>
                                                                <div className="d-flex align-items-center">
                                                                    <div className="icon-box text-primary">
                                                                        <i className="bi bi-calendar3"></i>
                                                                    </div>
                                                                    <span className="ms-2">{row.submitted_date}</span>
                                                                </div>
                                                                <div className="d-flex align-items-center">
                                                                    <div className="icon-box text-primary">
                                                                        <i className="bi bi-person-up"></i>
                                                                    </div>
                                                                    <span className="ms-2">{row.uploadedtosama_by}</span>
                                                                </div>
                                                            </>
                                                        )}

                                                    </div>
                                                </td>
                                            )}
                                            {Overridenby && (
                                                <td>
                                                    <div className="d-flex flex-column gap-1">
                                                        {row.Overridden_by && (
                                                            <>
                                                                <div className="d-flex align-items-center">
                                                                    <div className="icon-box text-primary">
                                                                        <i className="bi bi-calendar3"></i>
                                                                    </div>
                                                                    <span className="ms-2">{row.submitted_date}</span>
                                                                </div>

                                                                <div className="d-flex align-items-center">
                                                                    <div className="icon-box text-primary">
                                                                        <i className="bi bi-person-gear"></i>
                                                                    </div>
                                                                    <span className="ms-2">{row.Overridden_by}</span>
                                                                </div>
                                                            </>
                                                        )}
                                                    </div>
                                                </td>
                                            )}

                                            {/* Action */}

                                            <td>
                                                {[
                                                    "Pending for Checker Review",
                                                    "Past Data Pending for Checker Review",
                                                    "Data Reinstated",
                                                ].includes(row.status) && (
                                                        <button
                                                            className={`btn btn-sm btn-outline-primary ${shariahStyles.actionButton}`}
                                                            onClick={() => {
                                                                localStorage.setItem(
                                                                    "selectedReportingDate",
                                                                    row.reporting_date
                                                                );

                                                                if (
                                                                    row.status === "Past Data Pending for Checker Review" ||
                                                                    row.status === "Data Reinstated"
                                                                ) {
                                                                    navigate("/GapsyCompliancePastApprove");
                                                                } else {
                                                                    navigate("/GapsyComplianceReview");
                                                                }
                                                               
                                                            }}
                                                        >
                                                            <i className="bi bi-pencil me-1"></i>
                                                            Review
                                                        </button>
                                                    )}
                                            </td>

                                        </tr>

                                    ))}

                                </tbody>

                            </table>

                        </div>
                    </div>

                </div>
            </main>
            <Footer />
        </div>
    );
};

export default GapsyComplianceListReview;
